<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zEX4nG/tc-custom/9781460322819.jpg?1728259357491" alt="This image is the cover for the book Maverick's Christmas Baby, Montana Mavericks: Rust Creek Cowboys"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Maverick's Christmas Baby, Montana Mavericks: Rust Creek Cowboys
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>USA Today</i>–bestselling author, a blizzard brings together a pregnant woman and a single father, who fall in love despite their rival families.</b><br/><br/>RUST CREEK RAMBLINGS <br/><br/>Rejoice, ye merry Mavericks! As Christmas approaches, we here at The Rust Creek Falls Rambler thought we’d reward our devoted followers with a blind item guaranteed to put a little extra jingle in your stockings. Which rugged Rust Creek Traub has been spotted canoodling with a very pregnant lady of the Crawford kind? <br/><br/>Astute readers will guess we’re talking about divorced rancher Dallas Traub, who rescued expectant shopkeeper Nina Crawford from a snowy car wreck a few weeks back. Can these holiday honeys survive feuding families, three boisterous boys and a little bundle of joy intent on an early arrival? Only Santa knows for sure . . . and he might just be bringing the gift of love down the chimney this year!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Victoria Pade
      </h2>
      
      <p class="authorDescription body article">Victoria Pade is a USA Today bestselling author of multiple romance novels.&#160; She has two daughters and is a native of Colorado, where she lives and writes.&#160; A devoted chocolate-lover, she's in search of the perfect chocolate chip cookie recipe.&#160; Readers can find information about her latest and upcoming releases by logging on to <a href="http://www.vikkipade.com">www.vikkipade.com</a>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?177e5b28